export enum Role {
  Admin = 'Admin',
  Editor = 'Editor',
  User = 'User'
}
